import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function TermsAffiliate() {
  return (
    <LegalLayout title="Affiliate Terms of Service" eyebrow="Legal · Affiliates" lastUpdated="1 March 2026" version="1.0">
      <p>
        These Affiliate Terms of Service ("<strong>Terms</strong>") form a legally binding agreement between{" "}
        <strong>Connexis Group Ltd</strong>, company number <strong>17214446</strong> ("<strong>Connexis</strong>"),
        and the business entity or individual ("<strong>Affiliate</strong>") that refers prospective buyers to
        Connexis in exchange for a referral commission.
      </p>

      <h2>1. The programme</h2>
      <p>
        Connexis provides the Affiliate with unique tracking links and creative assets. The Affiliate promotes
        Connexis to prospective buyers. Where a referred buyer signs up and incurs paid usage, the Affiliate earns a
        percentage of that buyer's lifetime wallet spend.
      </p>

      <h2>2. Commission tiers</h2>
      <p>The default commission structure is:</p>
      <ul>
        <li><strong>Bronze (default)</strong>: 20% of referred-buyer wallet spend for the first 12 months.</li>
        <li><strong>Silver</strong> (≥5 active referred buyers): 30% for the first 12 months.</li>
        <li><strong>Gold</strong> (≥15 active referred buyers): 40% for the first 12 months.</li>
      </ul>
      <p>Tier upgrades apply prospectively to new referrals.</p>

      <h2>3. Attribution</h2>
      <ul>
        <li>Attribution is via tracking link (UTM + signed cookie) with a <strong>60-day</strong> last-click window.</li>
        <li>A referred buyer is "active" once they have topped up a wallet of at least £5,000.</li>
        <li>Self-referrals, referrals to entities under common control, and incentivised sign-ups are not eligible.</li>
      </ul>

      <h2>4. Promotion standards</h2>
      <p>The Affiliate must:</p>
      <ul>
        <li>Use only the official creatives and tracking links provided by Connexis.</li>
        <li>Not bid on Connexis brand terms in paid search.</li>
        <li>Not misrepresent the service, pricing or any feature.</li>
        <li>Not generate fake or low-intent sign-ups.</li>
        <li>Comply with UK advertising standards (CAP/BCAP, ASA).</li>
      </ul>

      <h2>5. Payment</h2>
      <ul>
        <li>Commissions accrue on the 1st of each month for the prior month's qualifying spend.</li>
        <li>Payouts are made monthly via Stripe Connect or bank transfer, minimum £50.</li>
        <li>The Affiliate is responsible for taxes payable on commission income.</li>
      </ul>

      <h2>6. Term &amp; termination</h2>
      <ul>
        <li>Open-ended. Either party may terminate for convenience on 30 days notice.</li>
        <li>Commissions accrued up to termination are paid in the next scheduled payout.</li>
        <li>Connexis may suspend or terminate immediately for breach of clause 4.</li>
      </ul>

      <h2>7. Liability &amp; governing law</h2>
      <p>
        Aggregate liability capped at commissions earned in the 12 months preceding the claim. English law,
        exclusive jurisdiction of the English courts.
      </p>

      <p className="!mt-12 !text-[13px] !text-slate-500">
        These Terms are signed on behalf of Connexis Group Ltd by its appointed director. The Affiliate's
        authorised signatory accepts these Terms by completing the e-signature flow in the affiliate portal.
      </p>
    </LegalLayout>
  );
}
